import Component from "./Orders";
export default Component;
